import './banners.css';
import Icon from '../icon/icon';
const Banner = (props) => {
    const gradients = {
        1:'rgba(164, 121, 228, 1)',
        2:'rgba(119, 184, 228, 1)'
    }
    return(
        <div className={`banner banner-type-${props.type}`}>
            <div className='banner-texts'>
                <h3 className='banner-texts-title'>{props.title}</h3>
                <p className='banner-texts-description'>{props.text}</p>
            </div>
            <div className='banner-skills'>
                <p className='banner-skills-title'>{props.skills}</p>
                <div className='banner-skills-icons'>{
                    props.icons.map((icon)=> <Icon source={icon} color={gradients[props.type]}></Icon>)
                    }
                </div>
            </div>
        </div>
    )
}

export default Banner;